import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'
import { Input } from 'core-components/library/inputs'
import { PARTNER_SCOPE_TRANSLATION_KEYS as KEYS } from 'partner360/features/welcomeFlow/configs/translations'

import type { TMyPartnersFilters } from '../../hooks/useMyPartnersFilters'

import styles from './MyPartnersControls.module.scss'

interface IMyPartnersControlsProps {
  filters: TMyPartnersFilters
  onAddPartner: () => void
}

const renderCheckboxLabel = (text: string, count: number) => (
  <div className={styles.checkboxLabel}>
    <Translation text={text} replaceParams={[{ key: '{count}', value: count.toString() }]} />
  </div>
)

export const MyPartnersControls = ({ filters, onAddPartner }: IMyPartnersControlsProps) => {
  const {
    searchString,
    setSearchString,
    onlyHeadquarters,
    setOnlyHeadquarters,
    onlyTopPartners,
    setOnlyTopPartners,
    onlyRequests,
    setOnlyRequests,
    counts,
  } = filters

  return (
    <div className={styles.root}>
      <div className={styles.filters}>
        <Input
          classes={{ root: styles.searchInput }}
          value={searchString}
          onChange={setSearchString}
          startContent={<i className="kbase kbase-search" />}
          endContent={
            searchString.length > 0 ? (
              <div className={styles.clearButton} onClick={() => setSearchString('')}>
                <i className="kbase kbase-close-circle" />
              </div>
            ) : undefined
          }
          label="Partner Name, Partner ID, Location ID"
        />
        <Checkbox
          label={renderCheckboxLabel(KEYS.onlyHeadquarters, counts.headquarters)}
          checked={onlyHeadquarters}
          onChange={setOnlyHeadquarters}
        />
        <Checkbox
          label={renderCheckboxLabel(KEYS.onlyTopPartners, counts.topPartners)}
          checked={onlyTopPartners}
          onChange={setOnlyTopPartners}
        />
        {/* Kept while checked: the count is taken from the filtered list, so removing the last
            request would otherwise hide the checkbox and leave the list stuck empty. */}
        {(counts.requests > 0 || onlyRequests) && (
          <Checkbox
            label={renderCheckboxLabel(KEYS.filterOnlyRequest, counts.requests)}
            checked={onlyRequests}
            onChange={setOnlyRequests}
          />
        )}
      </div>

      <div className={styles.actions}>
        <Button onClick={onAddPartner}>
          <Translation span text={KEYS.addPartner} />
        </Button>
      </div>
    </div>
  )
}

MyPartnersControls.displayName = 'MyPartnersControls'
